import React from 'react';
import { Section } from './Section';
import { Quote } from 'lucide-react';
export const Prueba = () => {
  return <Section data-id="element-209">
      <div className="max-w-4xl mx-auto relative" data-id="element-210">
        <div className="absolute -top-6 -left-6 text-gold/10" data-id="element-211">
          <Quote size={120} className="rotate-180" data-id="element-212" />
        </div>

        <div className="relative z-10 p-8 md:p-12 border border-gold/20 bg-gradient-to-br from-navy-800 to-navy-900 rounded-sm" data-id="element-213">
          <h2 className="text-2xl md:text-3xl font-serif text-gold mb-8 text-center" data-id="element-214">
            Lo que cambia en 7 días
          </h2>

          <div className="space-y-6 text-lg text-gray-300 font-light leading-relaxed" data-id="element-215">
            <p data-id="element-216">
              Al finalizar la primera semana aplicando el{' '}
              <strong className="text-offwhite font-medium" data-id="element-217">
                Blindaje de Doble Faz
              </strong>
              , notarás que tus compañeros tóxicos comienzan a alejarse de tu
              escritorio.
            </p>
            <p data-id="element-218">
              No es magia, es que ya no encuentran en vos el "alimento"
              emocional que buscaban.
            </p>
            <p className="text-xl font-serif text-gold-light italic text-center mt-8 pt-8 border-t border-gold/10" data-id="element-219">
              "Recuperarás el 40% de tu energía nocturna simplemente por dejar
              de filtrarla en discusiones que no te pertenecen."
            </p>
          </div>
        </div>
      </div>
    </Section>;
};